// extracted by mini-css-extract-plugin
export var actions = "_ru-4";
export var item = "_ru-1";
export var price = "_ru-3";
export var quantity = "_ru-2";
export var table = "_ru-0";